<template>
  <router-view/>
</template>

<script>
export default {
  created() {
    // console.log(this.$auth)
    // if (!this.$auth) {
    //   console.error('no $auth object')
    // } else {
    //   console.info('found $auth object')
    // }
    // this.$auth.$on('starting', () => {
    //   console.log('starting')
    // })
    this.$auth.$on('authenticated', (user) => {
      console.log('authenticated', user)
      this.loadRefData()
    })  
  },
  methods: {
    loadRefData() {
      // load ref data
      const refs = [
        { url: this.$api.resolvePath(`ref/positions`), mutation: 'setPositions' },
        { url: this.$api.resolvePath(`ref/locations`), mutation: 'setLocations' },
        { url: this.$api.resolvePath(`ref/places`), mutation: 'setPlaces' },
        { url: this.$api.resolvePath(`ref/timeGroups`), mutation: 'setTimeGroups' },
        { url: this.$api.resolvePath(`ref/types`), mutation: 'setTypes' },
      ]
      
      refs.forEach(({ url, mutation }) => {
        // fetch(url)
        this.$api.get(url)
          .then(res => res.json())
          .then(data => {
            this.$store.commit(mutation, data)
          })
          .catch(err => console.error(err))
      })
    },
  },
}
</script>

<style lang="scss">
.v-application a {
  &.plain {
    color: unset;
    text-decoration: unset;
  }
}

ul.comma-list,
.v-application ul.comma-list {
  display: inline;
  list-style: none;
  padding: 0px;

  li {
    display: inline;

    &::after {
      content: ", ";
    }

    &:last-of-type::after {
      content: "";
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.list-enter-active, .list-leave-active {
  transition: all 1s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  // transform: translateY(30px);
}

.fill-width {
  width: 100%;
}
</style>